import { apiFetch } from './apiClient';



export const listarTipos = () => apiFetch('/processo-tipos');

export const criarTipo = (dados) =>
  apiFetch('/processo-tipos', { method: 'POST', body: JSON.stringify(dados) });

export const atualizarTipo = (id, dados) =>
  apiFetch(`/processo-tipos/${id}`, { method: 'PUT', body: JSON.stringify(dados) });

export const excluirTipo = (id) =>
  apiFetch(`/processo-tipos/${id}`, { method: 'DELETE' });

export const criarEtapaTipo = (tipoId, dados) =>
  apiFetch(`/processo-tipos/${tipoId}/etapas`, { method: 'POST', body: JSON.stringify(dados) });

export const atualizarEtapaTipo = (tipoId, etapaId, dados) =>
  apiFetch(`/processo-tipos/${tipoId}/etapas/${etapaId}`, { method: 'PUT', body: JSON.stringify(dados) });

export const excluirEtapaTipo = (tipoId, etapaId) =>
  apiFetch(`/processo-tipos/${tipoId}/etapas/${etapaId}`, { method: 'DELETE' });

export const reordenarEtapasTipo = (tipoId, ids) =>
  apiFetch(`/processo-tipos/${tipoId}/etapas/reordenar`, { method: 'PUT', body: JSON.stringify({ ids }) });

/* fallback somente leitura -- mesmo conteúdo do seed inicial
   (backend/sql/processo_tipos_seed.sql), usado só quando a API está fora
   do ar, pra o módulo Processos continuar funcionando (sem conseguir
   editar o catálogo enquanto isso). "id" aqui é só a própria chave --
   não existe registro de verdade no banco nesse modo. */
const FALLBACK_CATALOGO = [
  {
    "id": "licenciamento",
    "chave": "licenciamento",
    "nome": "Licenciamento",
    "descricao": null,
    "ativo": true,
    "etapas": [
      {
        "id": "licenciamento-1",
        "ordem": 1,
        "nome": "Levantar CNAEs e endereço atual",
        "objetivo": "Confirmar qual atividade a empresa exerce de fato e onde.",
        "como_fazer": [
          "Consultar o cartão CNPJ atualizado na Receita Federal",
          "Listar CNAE principal e secundários",
          "Conferir o endereço da sede e se há filiais",
          "Registrar divergência entre a atividade cadastrada e a atividade real"
        ],
        "documentos": [
          "Cartão CNPJ atualizado"
        ],
        "escalar": "Atividade exercida diferente do CNAE registrado.",
        "ativo": true
      },
      {
        "id": "licenciamento-2",
        "ordem": 2,
        "nome": "Consultar licenças vigentes no município",
        "objetivo": "Identificar quais licenças a empresa possui e quais deveria possuir.",
        "como_fazer": [
          "Identificar o município da sede",
          "Consultar a inscrição municipal e a situação do alvará de funcionamento",
          "Verificar exigência de licença sanitária, ambiental e de uso e ocupação do solo conforme a atividade",
          "Anotar número, órgão emissor e validade de cada licença encontrada"
        ],
        "documentos": [
          "Alvará de funcionamento",
          "Licenças específicas da atividade"
        ],
        "escalar": "Município ainda não atendido pelo escritório, ou exigência não prevista.",
        "ativo": true
      },
      {
        "id": "licenciamento-3",
        "ordem": 3,
        "nome": "Verificar AVCB",
        "objetivo": "Confirmar a regularidade do imóvel junto ao Corpo de Bombeiros.",
        "como_fazer": [
          "Verificar se a atividade e o imóvel exigem AVCB ou CLCB",
          "Consultar a validade do documento existente",
          "Registrar ausência ou vencimento"
        ],
        "documentos": [
          "AVCB ou CLCB vigente"
        ],
        "escalar": "Imóvel sem AVCB quando exigido.",
        "ativo": true
      },
      {
        "id": "licenciamento-4",
        "ordem": 4,
        "nome": "Anexar comprovantes",
        "objetivo": "Deixar registrado no sistema tudo que comprova a análise.",
        "como_fazer": [
          "Anexar ou vincular o link de cada documento consultado",
          "Nomear os arquivos com padrão: CLIENTE_DOCUMENTO_ANO"
        ],
        "documentos": [
          "Todos os documentos das etapas anteriores"
        ],
        "escalar": "Documento que o cliente não fornece após duas solicitações.",
        "ativo": true
      },
      {
        "id": "licenciamento-5",
        "ordem": 5,
        "nome": "Classificar situação",
        "objetivo": "Definir o status de licenciamento do cliente.",
        "como_fazer": [
          "Regular: todas as licenças exigidas estão vigentes",
          "Irregular: falta licença exigida, ou há documento vencido",
          "Dispensado: a atividade e o município não exigem licenciamento",
          "Registrar o motivo da classificação no campo de observação"
        ],
        "documentos": [],
        "escalar": "Dúvida sobre exigência de licença para a atividade.",
        "ativo": true
      },
      {
        "id": "licenciamento-6",
        "ordem": 6,
        "nome": "Conclusão",
        "objetivo": "Consolidar o resultado no cadastro do cliente e apontar oportunidade de serviço.",
        "como_fazer": [
          "Preencher situação de licenciamento e datas de vencimento",
          "Se irregular, registrar na observação o que precisa ser regularizado",
          "Comunicar a coordenação sobre os casos irregulares"
        ],
        "documentos": [],
        "escalar": "Sempre comunicar casos irregulares antes de encerrar.",
        "ativo": true
      }
    ]
  },
  {
    "id": "abertura",
    "chave": "abertura",
    "nome": "Abertura de empresa",
    "descricao": "Aplica-se a sociedades empresárias e empresários individuais registrados na JUCESP. Não se aplica a associações, igrejas, fundações, condomínios, sociedades simples e sociedades de advogados -- esses têm rota própria em cartório ou OAB.",
    "ativo": true,
    "etapas": [
      {
        "id": "abertura-1",
        "ordem": 1,
        "nome": "Levantamento inicial com o cliente",
        "objetivo": "Reunir tudo que define a empresa antes de qualquer protocolo.",
        "como_fazer": [
          "Registrar a atividade que será exercida, na linguagem do cliente",
          "Solicitar 3 opções de nome empresarial em ordem de preferência",
          "Registrar nome fantasia, endereço da sede, capital social e forma de integralização",
          "Registrar quadro societário e percentual de cada sócio",
          "Registrar contato responsável e telefone"
        ],
        "documentos": [],
        "escalar": "Definição de CNAE, natureza jurídica e regime tributário -- decisão técnica, não presumir.",
        "ativo": true
      },
      {
        "id": "abertura-2",
        "ordem": 2,
        "nome": "Documentação",
        "objetivo": "Ter em mãos todos os documentos exigidos antes de abrir processo.",
        "como_fazer": [
          "Sócios: RG e CPF ou CNH, comprovante de endereço residencial",
          "Empresa: IPTU do imóvel, AVCB quando exigido, comprovante de endereço",
          "Conferir legibilidade e validade de cada documento"
        ],
        "documentos": [
          "RG/CPF ou CNH dos sócios",
          "Comprovantes de endereço",
          "IPTU",
          "AVCB"
        ],
        "escalar": "Imóvel alugado, endereço residencial, coworking ou imóvel rural.",
        "ativo": true
      },
      {
        "id": "abertura-3",
        "ordem": 3,
        "nome": "Contrato social",
        "objetivo": "Definir o instrumento de constituição.",
        "como_fazer": [
          "Regra: usar o contrato padrão da JUCESP sempre que a operação couber no modelo",
          "Contrato próprio apenas com cláusula específica: administração diferenciada, quórum especial, distribuição desproporcional de lucros, sócio pessoa jurídica"
        ],
        "documentos": [
          "Minuta do contrato"
        ],
        "escalar": "Qualquer situação que não caiba no contrato padrão.",
        "ativo": true
      },
      {
        "id": "abertura-4",
        "ordem": 4,
        "nome": "Viabilidade",
        "objetivo": "Confirmar que a atividade pode ser exercida naquele endereço.",
        "como_fazer": [
          "Antes de solicitar, verificar se a atividade gera resíduo, ruído, efluente ou impacto de vizinhança",
          "Nesses casos, solicitar também certidão de uso e ocupação do solo na prefeitura",
          "Solicitar a viabilidade na JUCESP"
        ],
        "documentos": [
          "IPTU",
          "Dados do imóvel"
        ],
        "escalar": "Viabilidade indeferida, ou dúvida sobre enquadramento quanto a resíduo/ruído.",
        "ativo": true
      },
      {
        "id": "abertura-5",
        "ordem": 5,
        "nome": "DBE",
        "objetivo": "Gerar o documento básico de entrada no REDESIM.",
        "como_fazer": [
          "Após o deferimento da viabilidade, solicitar a liberação no REDESIM / Coleta Nacional",
          "Gerar o DBE",
          "Conferir os dados contra a viabilidade antes de prosseguir"
        ],
        "documentos": [
          "DBE"
        ],
        "escalar": "Divergência de dados entre viabilidade e DBE.",
        "ativo": true
      },
      {
        "id": "abertura-6",
        "ordem": 6,
        "nome": "Processo de registro na JUCESP",
        "objetivo": "Montar o processo e gerar a taxa.",
        "como_fazer": [
          "Iniciar o processo de registro",
          "Emitir a taxa e encaminhar para pagamento",
          "Reunir os documentos adicionais exigidos para assinatura"
        ],
        "documentos": [
          "Guia da taxa",
          "Documentos exigidos pela Junta"
        ],
        "escalar": "Exigência de documento não previsto.",
        "ativo": true
      },
      {
        "id": "abertura-7",
        "ordem": 7,
        "nome": "Assinatura e protocolo",
        "objetivo": "Protocolar o registro.",
        "como_fazer": [
          "Colher as assinaturas dos sócios",
          "Protocolar pela via web, com assinatura do contador responsável",
          "Acompanhar o andamento até o deferimento"
        ],
        "documentos": [
          "Contrato assinado",
          "Comprovante de protocolo"
        ],
        "escalar": "Exigência ou indeferimento da Junta.",
        "ativo": true
      },
      {
        "id": "abertura-8",
        "ordem": 8,
        "nome": "Ativação do CNPJ e opção pelo regime",
        "objetivo": "Ativar o CNPJ e enquadrar a empresa no regime correto.",
        "como_fazer": [
          "Deferido o registro, o CNPJ é ativado",
          "A opção pelo Simples Nacional é feita NESTE ATO, junto com a ativação",
          "Não deixar o enquadramento para depois"
        ],
        "documentos": [
          "Comprovante de inscrição e situação cadastral"
        ],
        "escalar": "Regime tributário ainda não fechado com a diretoria.",
        "ativo": true
      },
      {
        "id": "abertura-9",
        "ordem": 9,
        "nome": "Inscrição municipal",
        "objetivo": "Obter o CCM.",
        "como_fazer": [
          "Verificar antes se o município exige processo prévio ou paralelo (ICAD e sistemas próprios)",
          "Protocolar a inscrição municipal"
        ],
        "documentos": [
          "CCM"
        ],
        "escalar": "Município não atendido pelo escritório, ou exigência não prevista.",
        "ativo": true
      },
      {
        "id": "abertura-10",
        "ordem": 10,
        "nome": "Licenciamento",
        "objetivo": "Obter as licenças exigidas para a atividade e o endereço.",
        "como_fazer": [
          "Identificar as licenças exigidas: alvará, sanitária, ambiental, bombeiros",
          "Protocolar cada uma e acompanhar"
        ],
        "documentos": [
          "Alvará e licenças específicas"
        ],
        "escalar": "Exigência que o imóvel não atende.",
        "ativo": true
      },
      {
        "id": "abertura-11",
        "ordem": 11,
        "nome": "Conselho de classe",
        "objetivo": "Registrar a empresa quando a atividade for profissão regulamentada.",
        "como_fazer": [
          "Verificar se a atividade é regulamentada",
          "Registrar a empresa e o responsável técnico no conselho competente"
        ],
        "documentos": [
          "Registro no conselho"
        ],
        "escalar": "Ausência de responsável técnico habilitado.",
        "ativo": true
      },
      {
        "id": "abertura-12",
        "ordem": 12,
        "nome": "Encerramento do processo",
        "objetivo": "Entregar a empresa pronta e iniciar a rotina.",
        "como_fazer": [
          "Confirmar opção pelo regime efetivada na etapa 8",
          "Providenciar inscrição estadual quando a atividade envolver ICMS",
          "Providenciar certificado digital e-CNPJ",
          "Entregar documentos e acessos ao cliente",
          "Cadastrar o cliente nos sistemas internos e iniciar a rotina mensal"
        ],
        "documentos": [
          "Pasta completa do cliente"
        ],
        "escalar": "Sempre comunicar a conclusão à coordenação.",
        "ativo": true
      }
    ]
  },
  {
    "id": "alteracao",
    "chave": "alteracao",
    "nome": "Alteração contratual",
    "descricao": null,
    "ativo": true,
    "etapas": [
      {
        "id": "alteracao-1",
        "ordem": 1,
        "nome": "Levantamento da alteração",
        "objetivo": "Definir com precisão o que muda.",
        "como_fazer": [
          "Registrar o que será alterado: endereço, atividade, nome, capital, sócios, administração",
          "Verificar se a alteração exige viabilidade"
        ],
        "documentos": [
          "Contrato social vigente e alterações anteriores"
        ],
        "escalar": "Entrada ou saída de sócio, alteração de capital, transformação de tipo societário.",
        "ativo": true
      },
      {
        "id": "alteracao-2",
        "ordem": 2,
        "nome": "Documentação",
        "objetivo": "Reunir os documentos da alteração.",
        "como_fazer": [
          "Documentos dos sócios envolvidos",
          "Documentos do novo endereço, quando houver mudança de sede"
        ],
        "documentos": [
          "RG/CPF ou CNH",
          "Comprovantes",
          "IPTU e AVCB do novo endereço"
        ],
        "escalar": "Documento faltante ou vencido.",
        "ativo": true
      },
      {
        "id": "alteracao-3",
        "ordem": 3,
        "nome": "Elaboração do contrato de alteração",
        "objetivo": "Redigir o instrumento.",
        "como_fazer": [
          "Não usar modelo padrão da JUCESP",
          "Redigir a cláusula alterada e a consolidação do contrato"
        ],
        "documentos": [
          "Minuta da alteração consolidada"
        ],
        "escalar": "Cláusula que exija análise jurídica.",
        "ativo": true
      },
      {
        "id": "alteracao-4",
        "ordem": 4,
        "nome": "Viabilidade",
        "objetivo": "Autorizar a mudança quando afeta endereço, atividade ou nome.",
        "como_fazer": [
          "Exigida em mudança de endereço, de atividade ou de nome empresarial",
          "Dispensada nas demais alterações -- registrar a dispensa e seguir"
        ],
        "documentos": [],
        "escalar": "Viabilidade indeferida.",
        "ativo": true
      },
      {
        "id": "alteracao-5",
        "ordem": 5,
        "nome": "DBE",
        "objetivo": "Gerar o DBE da alteração.",
        "como_fazer": [
          "Solicitar no REDESIM",
          "Conferir os dados contra a alteração pretendida"
        ],
        "documentos": [
          "DBE"
        ],
        "escalar": "Divergência de dados.",
        "ativo": true
      },
      {
        "id": "alteracao-6",
        "ordem": 6,
        "nome": "Processo na JUCESP",
        "objetivo": "Montar o processo e gerar a taxa.",
        "como_fazer": [
          "Iniciar o processo, emitir a taxa e reunir os documentos para assinatura"
        ],
        "documentos": [
          "Guia da taxa"
        ],
        "escalar": "Exigência não prevista.",
        "ativo": true
      },
      {
        "id": "alteracao-7",
        "ordem": 7,
        "nome": "Assinatura e protocolo",
        "objetivo": "Protocolar a alteração.",
        "como_fazer": [
          "Colher assinaturas e protocolar pela via web, assinado pelo contador",
          "Acompanhar até o deferimento"
        ],
        "documentos": [
          "Alteração assinada",
          "Comprovante de protocolo"
        ],
        "escalar": "Exigência ou indeferimento da Junta.",
        "ativo": true
      },
      {
        "id": "alteracao-8",
        "ordem": 8,
        "nome": "Atualização cadastral na Receita",
        "objetivo": "Refletir a alteração no CNPJ.",
        "como_fazer": [
          "Confirmar a atualização do cartão CNPJ após o deferimento",
          "Verificar impacto no regime tributário"
        ],
        "documentos": [
          "Cartão CNPJ atualizado"
        ],
        "escalar": "Alteração de atividade que impeça a permanência no Simples Nacional.",
        "ativo": true
      },
      {
        "id": "alteracao-9",
        "ordem": 9,
        "nome": "Atualização da inscrição municipal",
        "objetivo": "Atualizar o CCM.",
        "como_fazer": [
          "Protocolar a atualização no município",
          "Verificar exigência de processo próprio"
        ],
        "documentos": [
          "CCM atualizado"
        ],
        "escalar": "Município não atendido pelo escritório.",
        "ativo": true
      },
      {
        "id": "alteracao-10",
        "ordem": 10,
        "nome": "Revisão de licenciamento",
        "objetivo": "Verificar se a alteração afeta as licenças.",
        "como_fazer": [
          "Obrigatório quando houver mudança de atividade ou de endereço",
          "Revisar alvará, licenças e AVCB"
        ],
        "documentos": [
          "Licenças atualizadas"
        ],
        "escalar": "Licença que precisa ser refeita.",
        "ativo": true
      },
      {
        "id": "alteracao-11",
        "ordem": 11,
        "nome": "Conselho de classe",
        "objetivo": "Atualizar o registro quando aplicável.",
        "como_fazer": [
          "Comunicar a alteração ao conselho competente"
        ],
        "documentos": [
          "Registro atualizado"
        ],
        "escalar": "Mudança de responsável técnico.",
        "ativo": true
      },
      {
        "id": "alteracao-12",
        "ordem": 12,
        "nome": "Encerramento do processo",
        "objetivo": "Entregar e arquivar.",
        "como_fazer": [
          "Entregar a documentação atualizada ao cliente",
          "Atualizar o cadastro do cliente nos sistemas internos"
        ],
        "documentos": [
          "Pasta atualizada"
        ],
        "escalar": "Sempre comunicar a conclusão à coordenação.",
        "ativo": true
      }
    ]
  },
  {
    "id": "baixa",
    "chave": "baixa",
    "nome": "Baixa de empresa",
    "descricao": "Não se aplicam viabilidade e licenciamento nesse tipo.",
    "ativo": true,
    "etapas": [
      {
        "id": "baixa-1",
        "ordem": 1,
        "nome": "Diagnóstico prévio",
        "objetivo": "Confirmar que a empresa pode ser baixada.",
        "como_fazer": [
          "Verificar débitos federais, estaduais e municipais",
          "Verificar parcelamentos ativos",
          "Verificar se houve movimento no exercício da baixa",
          "Levantar certidões exigidas pelo município"
        ],
        "documentos": [
          "Certidões negativas",
          "Extrato de parcelamentos"
        ],
        "escalar": "Existência de débito ou parcelamento ativo.",
        "ativo": true
      },
      {
        "id": "baixa-2",
        "ordem": 2,
        "nome": "Documentação",
        "objetivo": "Reunir os documentos do encerramento.",
        "como_fazer": [
          "Documentos dos sócios",
          "Contrato social e alterações",
          "Definir o destino do acervo contábil e a responsabilidade pela guarda"
        ],
        "documentos": [
          "RG/CPF ou CNH",
          "Contrato consolidado"
        ],
        "escalar": "Sócio ausente ou falecido.",
        "ativo": true
      },
      {
        "id": "baixa-3",
        "ordem": 3,
        "nome": "Distrato",
        "objetivo": "Redigir o ato de encerramento.",
        "como_fazer": [
          "Elaborar o distrato social ou o requerimento de baixa",
          "Indicar responsável pela guarda dos livros e documentos"
        ],
        "documentos": [
          "Minuta do distrato"
        ],
        "escalar": "Divergência entre sócios quanto ao encerramento.",
        "ativo": true
      },
      {
        "id": "baixa-4",
        "ordem": 4,
        "nome": "Obrigações acessórias de encerramento",
        "objetivo": "Transmitir as declarações de situação especial.",
        "como_fazer": [
          "MEI: DASN-SIMEI de baixa",
          "Simples Nacional: DEFIS de situação especial",
          "Lucro Presumido e Real: ECD e ECF de situação especial; EFD-ICMS/IPI e EFD-Contribuições quando aplicável",
          "Encerrar as obrigações de folha, quando houver empregados"
        ],
        "documentos": [
          "Recibos de transmissão"
        ],
        "escalar": "Escrituração incompleta no período.",
        "ativo": true
      },
      {
        "id": "baixa-5",
        "ordem": 5,
        "nome": "Processo na JUCESP",
        "objetivo": "Montar o processo e gerar a taxa.",
        "como_fazer": [
          "Iniciar o processo de baixa, emitir a taxa e reunir os documentos"
        ],
        "documentos": [
          "Guia da taxa"
        ],
        "escalar": "Exigência não prevista.",
        "ativo": true
      },
      {
        "id": "baixa-6",
        "ordem": 6,
        "nome": "Assinatura e protocolo",
        "objetivo": "Protocolar a baixa.",
        "como_fazer": [
          "Colher assinaturas e protocolar pela via web, assinado pelo contador",
          "Acompanhar até o deferimento"
        ],
        "documentos": [
          "Distrato assinado",
          "Comprovante de protocolo"
        ],
        "escalar": "Exigência ou indeferimento da Junta.",
        "ativo": true
      },
      {
        "id": "baixa-7",
        "ordem": 7,
        "nome": "Baixa das inscrições",
        "objetivo": "Encerrar os cadastros municipal e estadual.",
        "como_fazer": [
          "Protocolar a baixa da inscrição municipal",
          "Protocolar a baixa da inscrição estadual, quando houver",
          "Confirmar a baixa do CNPJ na Receita"
        ],
        "documentos": [
          "Comprovantes de baixa"
        ],
        "escalar": "Município que exige processo próprio ou vistoria.",
        "ativo": true
      },
      {
        "id": "baixa-8",
        "ordem": 8,
        "nome": "Baixa no conselho de classe",
        "objetivo": "Encerrar o registro profissional da empresa.",
        "como_fazer": [
          "Comunicar o encerramento ao conselho competente, quando houver registro"
        ],
        "documentos": [
          "Comprovante de baixa no conselho"
        ],
        "escalar": "Anuidade em aberto no conselho.",
        "ativo": true
      },
      {
        "id": "baixa-9",
        "ordem": 9,
        "nome": "Encerramento do processo",
        "objetivo": "Entregar e arquivar.",
        "como_fazer": [
          "Entregar ao cliente todos os comprovantes de baixa",
          "Definir e registrar onde ficará o acervo contábil",
          "Inativar o cliente nos sistemas internos e encerrar a rotina mensal"
        ],
        "documentos": [
          "Pasta de encerramento"
        ],
        "escalar": "Sempre comunicar a conclusão à coordenação.",
        "ativo": true
      }
    ]
  }
];

export async function carregarCatalogo() {
  try {
    const r = await listarTipos();
    return r.items || [];
  } catch {
    return FALLBACK_CATALOGO;
  }
}
